/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useContext } from 'react';

const CRMCustomHeaderContext = createContext({
    isCRMPrescripteurPath: false,
    setIsCRMPrescripteurPath: (_: boolean) => {},
    offerName: undefined as string | undefined,
    setOfferName: (_: string | undefined) => {},
});

export const useCRMCustomHeader = () => useContext(CRMCustomHeaderContext);

export default CRMCustomHeaderContext;
